import { type ClientService } from '@feathersjs/feathers'
import {
  serviceStores,
  taskServiceStores,
  procurementServiceStores,
  type ServiceStores,
} from '@restify/packages/composables/useStore'
import useFeathers from './useFeathers'

const feathersClient = useFeathers()

export interface ServiceTypes
  extends Record<keyof ServiceStores, ClientService> {
  ['auth-management']: ClientService
}

type StoresType = ReturnType<typeof serviceStores> &
  ReturnType<typeof taskServiceStores> &
  ReturnType<typeof procurementServiceStores>

let stores: null | StoresType = null
export type Stores = StoresType

export default () => {
  if (stores === null) {
    const base = serviceStores(feathersClient)
    const procurement = procurementServiceStores(feathersClient)
    let tasks = {} as ReturnType<typeof taskServiceStores>
    try {
      tasks = taskServiceStores(feathersClient)
    } catch (e) {
      console.error('Failed to init task stores:', e)
    }
    stores = { ...base, ...tasks, ...procurement }
  }

  return stores
}
